export function formatEchoMinutes(durations: number[]): string {
  const seconds = durations.reduce(
    (sum, duration) =>
      Number.isFinite(duration) && duration > 0 ? sum + duration : sum,
    0,
  );

  if (seconds <= 0) return "";
  return `${Math.max(1, Math.floor(seconds / 60))}min`;
}
